<div class="container border bg-white p-3">
  <h4 class="pb-2 mb-2 pt-2 border-bottom" [innerHTML]="article.title"></h4>
  <div [innerHTML]="article.document | htmlTrust"></div>
</div>
